module.exports = __webpack_public_path__ + "static/crab-3-6fec3bcdd6d018a2efc0e0e8a25bb7e5.png";